import _ from "lodash";
import firebase from "./firebase";
import request from "../infra/request";

export const _transformTemplates = (emailTemplates) => {
  if (_.isNull(emailTemplates)) {
    return [];
  }
  return Object.keys(emailTemplates).map((id) => ({
    id,
    ...emailTemplates[id],
  }));
};

export const getAllEmailTemplates = async () => {
  let result = [];
  try {
    const response = await request.get("/admin/email-templates");
    const emailTemplates = response.data.templates;

    if (_.isNull(emailTemplates)) {
      return { result, error: null };
    }
    return { result: _transformTemplates(emailTemplates), error: false };
  } catch (err) {
    console.log(err);
    return { result, error: true };
  }
};

// Settings → Email Templates. Each rejects when the request fails; the page catches.
export const createEmailTemplate = async ({ type, name, subject, body }) => {
  const response = await request.post("/admin/email-templates", { type, name, subject, body });
  return response.data.id;
};

export const setEmailTemplate = (id, { type, name, subject, body }) =>
  request.put(`/admin/email-templates/${id}`, { type, name, subject, body });

export const removeEmailTemplate = (id) => request.delete(`/admin/email-templates/${id}`);

export const updateEmailTemplate = async (emailTemplates) => {
  const newEmailTemplates = emailTemplates.reduce((templates, { id, name, body, subject, type }) => {
    return {
      ...templates,
      [id]: { name, body, subject, type },
    };
  }, {});

  try {
    await firebase
      .database()
      .ref()
      .update({
        [`/email_templates`]: newEmailTemplates,
      });
    return { result: "", error: false };
  } catch (err) {
    console.log(err);
    return { result: "", error: true };
  }
};
